// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_BLOG_PHOTOS = "Fotky zo steny";
export const PHOTOS_SHOW_MORE = "Viac zo steny...";
